import React, { useState, useEffect } from 'react';
import { CnSwitch, CnButton, CnBalloon, CnIcon } from '@alife/cn-ui';
import {
  pluginPropsKeyPrefix,
  pluginExtSchemaPrefix,
} from 'src/plugins/use-cn-one-search';
import { createAppAndGetBizAccessKey, asyncDictToFlamingo } from './async-dict';

import './index.scss';

export default ({ prop: setterProp }) => {
  const node = setterProp.getNode();

  const [info, setInfo] = useState();
  const [asyncLoading, setAsyncLoading] = useState(false);
  const [open, setOpen] = useState(setterProp.getHotValue());

  useEffect(() => {
    setterProp.setHotValue(open);
  }, [open]);

  useEffect(async () => {
    if (open && !getSchemaAccessKey()) {
      setSchemaAccessKey((await createAppAndGetBizAccessKey()) || '');
    }
  }, []);
  /**
   * 实时获取schema上的AccessKey
   * @param {*}
   */
  const getSchemaAccessKey = () =>
    node.getPropValue(
      `${pluginExtSchemaPrefix}.${pluginPropsKeyPrefix}bizAccessKey`,
    );

  /**
   * 设置schema上的AccessKey
   * @param {*} AccessKey
   */
  const setSchemaAccessKey = (AccessKey) =>
    node.setPropValue(
      `${pluginExtSchemaPrefix}.${pluginPropsKeyPrefix}bizAccessKey`,
      AccessKey,
    );

  /**
   * 创建flamingo应用
   * @param {*} openV 开关
   */
  const openOneSearch = async (openV) => {
    setOpen(openV);
    if (!openV) return;
    if (!getSchemaAccessKey())
      setSchemaAccessKey((await createAppAndGetBizAccessKey()) || '');
  };

  /**
   * 同步词典
   * @param {*} open 开关
   */
  const asyncDict = async () => {
    setAsyncLoading(true);

    const columnList = node.getPropValue('config');
    const { success, errMsg } = await asyncDictToFlamingo({
      bizAccessKey: getSchemaAccessKey(),
      columnList,
    });
    setInfo(success ? '' : errMsg);

    setAsyncLoading(false);
  };

  return (
    <div className='switch-wrap'>
      <CnSwitch defaultChecked={open} onChange={openOneSearch} />
      <CnButton
        x-if={open}
        type='secondary'
        size='small'
        loading={asyncLoading}
        style={{ marginLeft: '6px' }}
        onClick={asyncDict}
      >
        同步词典
      </CnButton>
      <CnBalloon
        x-if={info}
        className='dictInfoWrap'
        triggerType='click'
        trigger={
          <CnIcon className='dictInfoWrap-icon' type='info-r' size='large' />
        }
      >
        {info}
      </CnBalloon>
      <CnButton
        x-if={open}
        className='appInfoWrap'
        type='primary'
        text
        onClick={() => {
          window.open(
            `https://flamingo.cainiao-inc.com/ams/workSpace/application/oneSearchBoxDetails?bizAccessKey=${getSchemaAccessKey()}`,
          );
        }}
      >
        查看算法应用
      </CnButton>
    </div>
  );
};
